import { Component, effect, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-toast-container',
    imports: [NgbToastModule],
    templateUrl: './toast-container.component.html',
    styleUrls: ['./toast-container.component.less'],
})
export class ToastContainerComponent {
    readonly toastService = inject(NotificationService);

    constructor() {}

    getToastClass(toast: any): string {
        switch (toast.type) {
            case 'success':
                return 'text-light bg-success border-success';
            case 'error':
                return 'text-light bg-danger border-danger';
            case 'warning':
                return 'text-dark bg-warning border-warning';
            case 'info':
                return 'text-light bg-info border-info';
            default:
                return 'text-light bg-info border-info';
        }
    }
}
